export default __webpack_public_path__ + "static/cart_is_ready-3212f227b4e4a87048b5f3fc3e41dbc4.png";